export default {
    name: 'acidity',
    serverName: '​/api/v1/normative_calculator/acidity_group/',
    apiUrl: '/api/v1/normative_calculator/acidity_group/'
};
